if (!customElements.get('bott-slider-pagination')) {
  customElements.define(
    'bott-slider-pagination',
    class BottSliderPagination extends HTMLElement {
      constructor() {
        super();
        this.onSlideChanged = this.onSlideChanged.bind(this);
        this.onClick = this.onClick.bind(this);
      }

      connectedCallback() {
        this.targetSlider = document.getElementById(this.dataset.target);
        if (!this.targetSlider) return;
        this.targetSlider.addEventListener('slideChanged', this.onSlideChanged);
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        if (!this.targetSlider) return;
        this.targetSlider.removeEventListener('slideChanged', this.onSlideChanged);
      }

      onSlideChanged(event) {
        this.setActive(event.detail.currentPage);
      }

      onClick(event) {
        const button = event.target.closest('button[data-slide-index]');
        if (!button || !this.targetSlider.slider || !this.targetSlider.sliderItemOffset) return;
        const index = Number(button.dataset.slideIndex);
        this.targetSlider.slider.scrollTo({ left: (index - 1) * this.targetSlider.sliderItemOffset });
      }

      setActive(currentPage) {
        this.querySelectorAll('button[data-slide-index]').forEach((button) => {
          if (Number(button.dataset.slideIndex) === currentPage) {
            button.setAttribute('aria-current', 'true');
          } else {
            button.removeAttribute('aria-current');
          }
        });
      }
    }
  );
}
